import React, { useMemo } from "react";

import { useTranslation } from "react-i18next";

import NotationTableCell from "@components/evaluation/NotationTableCell";
import Button from "@components/tailwindComponents/Button";
import BlackTooltip from "@components/tooltip/BlackTooltip";

export default function CriteriaItem(props) {
  const { evaluationCriteria, openModalUpsertObjective, readOnly, goToDetail } =
    props;

  return (
    <tr className="arh-border arh-border-x-0 arh-border-t-0 arh-border-solid arh-border-borderTable">
      <td className="arh-py-[0.688rem] arh-px-4">
        <BlackTooltip
          title={evaluationCriteria.name}
          placement="top-start"
        >
          <div className="arh-max-w-fit arh-line-clamp-2 arh-text-start arh-font-poppins arh-text-xs arh-font-semibold arh-text-darkColor">
            {evaluationCriteria.name}
          </div>
        </BlackTooltip>
      </td>
      {/* Status comme dans items status.js */}
      <NotationTableCell
        evaluationFormat={evaluationCriteria.evaluationFormat}
        note={evaluationCriteria.notation?.note}
        onClick={goToDetail}
      />
      <td className="arh-py-[0.688rem] arh-px-4">
        <BlackTooltip
          title={
            evaluationCriteria.notation?.EvaluationObjective?.nextObjective ||
            "-"
          }
          placement="top-start"
        >
          <div className="arh-flex arh-items-center arh-justify-center">
            <span className="arh-w-full arh-whitespace-break-spaces arh-text-start arh-font-poppins arh-text-xs arh-font-semibold arh-text-darkColor arh-line-clamp-3 arh-max-w-fit ">
              {evaluationCriteria.notation?.EvaluationObjective?.nextObjective ||
                "-"}
            </span>
          </div>
        </BlackTooltip>
      </td>
      <td className="arh-py-[0.688rem] arh-px-4  ">
        <BlackTooltip
          title={
            evaluationCriteria.notation?.EvaluationObjective?.availableMeans ||
            "-"
          }
          placement="top-start"
        >
          <div className="arh-flex arh-items-center arh-justify-center">
            <span className="arh-w-full arh-whitespace-break-spaces arh-text-start arh-font-poppins arh-text-xs arh-font-semibold arh-text-darkColor arh-line-clamp-3 arh-max-w-fit ">
              {evaluationCriteria.notation?.EvaluationObjective?.availableMeans ||
                "-"}
            </span>
          </div>
        </BlackTooltip>
      </td>
      <td className="arh-py-[0.688rem] arh-px-4  ">
        <BlackTooltip
          title={
            evaluationCriteria.notation?.EvaluationObjective?.mainObjective ||
            "-"
          }
          placement="top-start"
        >
          <div className="arh-flex arh-items-center arh-justify-center">
            <span className="arh-w-full arh-whitespace-break-spaces arh-text-start arh-font-poppins arh-text-xs arh-font-semibold arh-text-darkColor arh-line-clamp-3 arh-max-w-fit ">
              {evaluationCriteria.notation?.EvaluationObjective?.mainObjective ||
                "-"}
            </span>
          </div>
        </BlackTooltip>
      </td>

      <td className="arh-px-4">
        <div className="arh-mx-4 arh-my-[0.3rem] arh-flex arh-items-center arh-justify-end">
          <CriteriaItemButton
            readOnly={readOnly}
            objective={evaluationCriteria.notation?.EvaluationObjective}
            onClick={() => openModalUpsertObjective(evaluationCriteria)}
          />
        </div>
      </td>
    </tr>
  );
}

function CriteriaItemButton(props) {
  const { readOnly, objective } = props;
  const { t: translator } = useTranslation("assesment.frequency");

  const hasObjective = useMemo(() => {
    if (!objective) {
      return false;
    }

    return (
      objective.nextObjective ||
      objective.availableMeans ||
      objective.mainObjective
    );
  }, [objective]);

  if (readOnly) {
    if (!hasObjective) {
      return null;
    }

    return (
      <Button
        variant="green-outlined"
        onClick={props.onClick}
      >
        {translator("Visualiser")}
      </Button>
    );
  }

  // If not readOnly from here
  if (hasObjective) {
    return (
      <Button
        variant="green-outlined"
        onClick={props.onClick}
      >
        {translator("Modifier")}
      </Button>
    );
  }

  return (
    <Button
      variant="outlined"
      onClick={props.onClick}
    >
      {translator("Ajouter")}
    </Button>
  );
}
